import React from 'react';
import { motion } from 'framer-motion';
import { PaletteIcon, FileTextIcon, ZapIcon, GlobeIcon, ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { TrustLine } from './TrustLine';
import { offer } from '../data/offer';
const chips = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso digital tras el pago'
}, {
  icon: GlobeIcon,
  label: 'Toda LATAM'
}, {
  icon: PaletteIcon,
  label: 'De 5 a 9 años'
}];
const stats = [{
  value: '6',
  label: 'Tomos'
}, {
  value: '5',
  label: 'Bonos'
}, {
  value: '315',
  label: 'Páginas'
}, {
  value: '60',
  label: 'Imprimibles'
}, {
  value: 'LATAM',
  label: 'Toda la región'
}];
export function Hero({
  guaranteeEnabled
}: {
  guaranteeEnabled: boolean;
}) {
  const trust = [...(guaranteeEnabled ? [{
    icon: ShieldCheckIcon,
    label: 'Garantía 7 días*'
  }] : []), {
    icon: LockIcon,
    label: 'Pago seguro'
  }, {
    icon: CreditCardIcon,
    label: 'Paga en tu moneda local'
  }];
  return <header className="relative overflow-hidden bg-ink" data-id="element-117" data-mp="3j9tzsvxzjik8">
      <div className="relative mx-auto max-w-5xl px-5 pb-16 pt-14 text-center sm:pt-20" data-id="element-118" data-mp="3o7bzdvq44lfk">
        <p className="flex items-center justify-center gap-2 text-sm font-black uppercase tracking-[0.25em] text-brand sm:text-base" data-id="element-119" data-mp="39acwgl67hgrf">
          <PaletteIcon className="h-5 w-5" aria-hidden="true" data-id="element-120" data-mp="3e8efj63mtg2w" />
          ReadyKit Digital™
        </p>

        <h1 className="mt-6 text-[2.6rem] font-black leading-[1.02] tracking-tight text-white sm:text-6xl lg:text-7xl" data-id="element-121" data-mp="30gzu6sm952so">
          Todo el entretenimiento sin pantallas.
          <span className="mt-2 block text-brand" data-id="element-122" data-mp="2qk3lomwcsgo4">Listo. Desde hoy.</span>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-lg font-semibold text-cream/90 sm:text-xl" data-id="element-123" data-mp="2viy2xkeo9x64">
          Menos tiempo buscando ideas. Más tiempo creando recuerdos en familia.
        </p>

        <motion.img src={offer.mockupImage} alt="MegaPack Antipantallas Listo: caja con los 6 tomos, imprimibles y sello de 6 tomos más 5 bonos" className="mx-auto mt-10 w-full max-w-[560px] drop-shadow-[0_30px_60px_rgba(0,0,0,0.55)]" initial={{
        opacity: 0,
        y: 16,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-124" data-mp="2hlj8g19kaz7a" />

        <h2 className="mx-auto mt-10 max-w-3xl text-2xl font-black uppercase leading-tight text-brand sm:text-3xl" data-id="element-125" data-mp="de6p6ubtw7md">
          MegaPack Antipantallas Listo — Combo completo
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg font-bold text-white" data-id="element-126" data-mp="161auz1iqwpz7">
          El sistema de actividades listas para usar para familias de LATAM — Niños de 5 a 9 años — 6 mundos de diversión.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-base text-muted sm:text-lg" data-id="element-127" data-mp="x0306tffu79v">
          Actividades + juegos + experimentos + manualidades + imprimibles. Sin buscar. Sin improvisar. Sin pasar horas preparando.
        </p>

        <ul className="mt-7 flex flex-wrap justify-center gap-2" data-id="element-128" data-mp="3hpsft8nytx3m">
          {chips.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-2 rounded-full border border-line bg-surface px-4 py-2 text-sm font-bold text-cream" data-id="element-129" data-mp="1x785vq9lpvv6">
              <Icon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-130" data-mp="269r2vtqphe9i" />
              {label}
            </li>)}
        </ul>

        <div className="mt-9" data-id="element-131" data-mp="2b20qv489g495">
          <CTAButton href={offer.checkoutUrl} data-id="element-132" data-mp="2fzss4ousp2q0">Quiero mi MegaPack ahora</CTAButton>
        </div>
        <div className="mt-5" data-id="element-133" data-mp="2kyvntiovxwlb">
          <TrustLine items={trust} data-id="element-134" data-mp="2ky44p7ch5rbx" />
        </div>

        <dl className="mx-auto mt-12 grid max-w-4xl grid-cols-2 gap-px overflow-hidden rounded-2xl border border-line bg-line sm:grid-cols-5" data-id="element-135" data-mp="2l0zzwnwxu1wo">
          {stats.map((s, i) => <div key={s.label} className={`bg-surface px-4 py-5 ${i === stats.length - 1 ? 'col-span-2 sm:col-span-1' : ''}`} data-id="element-136" data-mp="2tz1ykwt78igs" data-mpi={i}>
              <dt className="sr-only" data-id="element-137" data-mp="zkra4pginqbj">{s.label}</dt>
              <dd data-id="element-138" data-mp="znn9mi80in23">
                <span className="block text-3xl font-black text-white" data-id="element-139" data-mp="4be0pqxbgttw">{s.value}</span>
                <span className="mt-1 block text-xs font-black uppercase tracking-widest text-brand" data-id="element-140" data-mp="4d77r7budg2f">{s.label}</span>
              </dd>
            </div>)}
        </dl>

        <p className="mx-auto mt-6 max-w-2xl text-xs leading-relaxed text-muted/70" data-id="element-141" data-mp="e8sd9fg4cygx">
          {guaranteeEnabled && 'La garantía debe estar habilitada en las condiciones reales de venta. '}
          El cobro en moneda local depende de los países y monedas activados en el checkout.
        </p>
      </div>
    </header>;
}